import {useEffect, useState} from "react";

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler); // Cleanup timeout on value or delay change
        };
    }, [value, delay]);

    return debouncedValue;
}

export default useDebounce;
